// Rutas del candado de 2FA obligatorio. Módulo sin dependencias: lo usan el
// candado (`SecurityGate`) y sus pruebas sin arrastrar la app.

/** Donde el alta manual confirma su correo con el código (CC-CONSOLE#1550). */
export const SIGNUP_VERIFY_PATH = "/verificar";

/** A dónde se manda a quien está obligado a activar 2FA. */
export const SECURITY_SETUP_PATH = "/profile?tab=settings&security=required";

/**
 * Pantallas que siguen abiertas con el 2FA obligatorio pendiente: el perfil
 * (ahí se configura) y las que no son de una sesión (entrada, registro,
 * recuperación, enlaces públicos).
 */
const OPEN_PREFIXES = [
  "/profile",
  "/splash",
  "/register",
  // Verificación del alta manual (CC-CONSOLE#1550).
  "/verificar",
  "/confirm-session-reset",
  "/reset-password",
  "/soporte",
  "/mis-tickets",
  "/trackingLinks",
  "/tracking-replay",
  "/shop",
  "/espacios",
  // Tienda pública de boletos de Gestión de Pasajeros (/rides/:slug).
  "/rides",
  // Cotización pública del cliente (#1545).
  "/cotizacion",
  // Ticket de recoger en mostrador (QR) de ventas del POS.
  "/recoger",
];

export function isSecurityOpenPath(pathname: string): boolean {
  if (pathname === "/" || pathname === "") return true;
  return OPEN_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
}
